import { THOUSANDS_REGEX } from '../../constants';

const NON_DIGIT_REGEX = /[^0-9]/g;

class IntegerFormatter {
  static tryParse(format) {
    return format === 'integer' ? new IntegerFormatter() : null;
  }

  /**
   * Shared by apply() and parse(): a leading minus sign plus the digits before the first decimal point,
   * nothing else. Numbers are read without exponent notation (1e21).
   * Strings are read by their digits only, never through Number(): a string in exponent form like '1e3' reads as
   * '13', not 1000. Accepted on purpose, since saved values are never strings in exponent form, and Number() would
   * also accept hex ('0x1A') and 'Infinity'.
   */
  static clean(value) {
    const text =
      typeof value === 'number' ? value.toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 20 }) : value.toString();
    const digits = text.split('.')[0].replace(NON_DIGIT_REGEX, '');

    return digits && text.trimStart().startsWith('-') ? `-${digits}` : digits;
  }

  apply(value) {
    if (value === undefined || value === null || value === '') return value;

    const cleaned = IntegerFormatter.clean(value);
    const digits = cleaned.replace('-', '').replace(/^0+(?=\d)/, '');
    if (!digits) return undefined;

    const sign = cleaned.startsWith('-') && digits !== '0' ? '-' : '';
    // Insert a comma every 3 digits (display only; parse() saves the bare digits).
    return sign + digits.replace(THOUSANDS_REGEX, ',');
  }

  parse(value) {
    if (!value) return value;
    return IntegerFormatter.clean(value);
  }
}

export default IntegerFormatter;
